package com.sweetlime.bingeamigo.presentation.components

import androidx.compose.runtime.Composable
import com.sweetlime.bingeamigo.presentation.ui.BrandColors

enum class LibraryTab { WATCHLIST, WATCHED, TRACKING, COMPLETED, FAVORITES }

private val MOVIE_TABS = listOf(LibraryTab.WATCHLIST, LibraryTab.WATCHED, LibraryTab.FAVORITES)
private val MOVIE_LABELS = listOf("Watchlist", "Watched", "Favorites")

private val TV_TABS = listOf(LibraryTab.TRACKING, LibraryTab.COMPLETED, LibraryTab.FAVORITES)
private val TV_LABELS = listOf("Tracking", "Completed", "Favorites")

@Composable
fun MovieLibrarySegmentedControl(
    selected: LibraryTab,
    counts: Map<LibraryTab, Int>,
    onSelect: (LibraryTab) -> Unit,
) {
    SegmentedControl(
        tabs = MOVIE_LABELS,
        selected = MOVIE_TABS.indexOf(selected),
        onSelect = { onSelect(MOVIE_TABS[it]) },
        counts = MOVIE_TABS.map { counts[it] ?: 0 },
        activeColor = BrandColors.Secondary
    )
}

@Composable
fun TvLibrarySegmentedControl(
    selected: LibraryTab,
    counts: Map<LibraryTab, Int>,
    onSelect: (LibraryTab) -> Unit,
) {
    SegmentedControl(
        tabs = TV_LABELS,
        selected = TV_TABS.indexOf(selected),
        onSelect = { onSelect(TV_TABS[it]) },
        counts = TV_TABS.map { counts[it] ?: 0 },
        activeColor = BrandColors.Secondary
    )
}

@Composable
fun LibrarySegmentedControl(
    selected: LibraryTab,
    counts: Map<LibraryTab, Int>,
    onSelect: (LibraryTab) -> Unit,
) {
    MovieLibrarySegmentedControl(selected = selected, counts = counts, onSelect = onSelect)
}